export default __webpack_public_path__ + "static/media/news3.4cfe6a63.png";